import { render } from "./CardsInformativosConteiner.vue?vue&type=template&id=4bfc55e9&scoped=true"
import script from "./CardsInformativosConteiner.vue?vue&type=script&lang=js"
export * from "./CardsInformativosConteiner.vue?vue&type=script&lang=js"

import "./CardsInformativosConteiner.vue?vue&type=style&index=0&id=4bfc55e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfc55e9"]])

export default __exports__